import { observable } from "mobx";

export default class TagState {

    @observable checked = false;
    constructor(public name: string) { }
}



// WEBPACK FOOTER //
// ./docs-src/demos/simpsons/TagState.ts